import React from 'react';
import Registration from './Registration';

export const Default = () => {
  // Get registration settings from context if available
  const title = 'Signup';
  const description = '* Required';

  // Prepare registration props
  const registrationProps = {
    title,
    description,
  };

  return <Registration {...registrationProps} />;
};
